'use client'

import React from "react";
import bg from '../../public/Unleash.jpeg'
// import Image from "next/image";
import AccordionPanel from "./AccordionPanel";
import {ContentResponse, TestResponse} from "../../services/api.response.service";
import CourseCardItem from "../CourseCardItem";
import {RouteEndpoints} from "../../services/route.service";
import {useSelector} from "react-redux";
import {IRootState} from "../../redux/states";


import WatchSVG from "../../assets/svg/video-ic.svg";
import ReadSVG from "../../assets/svg/read-ic.svg";
import AudioSVG from "../../assets/svg/audio-ic.svg";
import {getLanguageByDefault} from "../../services/app.service";
import Languages from "../Languages";


export default function TestsSection({
                                         tests,
                                         isShortForm = false,
                                         handleSetTest,
                                       }: {
  tests: Array<TestResponse>,
  isShortForm?: boolean | false,
    handleSetTest: (id: string) => void;
}) {

  const getLanguage = getLanguageByDefault();
  const [activeSector, setActiveSector] = React.useState<number>(-1)

  const stateAll = useSelector((state: IRootState) => state);
  const currentUser = stateAll.setting.user!;



  // let isShortForm = false;
  return <div
      className='col-12'
      // className='flex flex-col lg:gap-y-7 gap-y-3'
  >

    {
      tests.map(
          (theTest, i) =>
          <AccordionPanel key={i}
                          // content={theTest}
                          title={theTest.name}
                          subTitle={theTest.description}
                          showItems={false}
                          setIsOpen={()=>setActiveSector((previous) => previous == i ? -1 : i)}
                          isOpen={activeSector == i}
                          handleHeadClick={() => {
                              handleSetTest && handleSetTest(String(theTest?.id));

                          }}

          >
            <div>
            </div>
          </AccordionPanel>
      )
    }
  </div>
}